import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  width: '100%',
  mt: 3,
};

export const group: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const groupHeader: SxStyleFunc<boolean | undefined> = (
  isMostPopular
) => ({
  bgcolor: isMostPopular ? 'rgba(255,255,255,0.15)' : 'grey.100',
  borderRadius: 0.5,
  p: 0.5,
});

export const featureList: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
  px: 0.5,
};

export const featureRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const featureLeft: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  flex: 1,
  minWidth: 0,
};

export const poweredByRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  pl: 3.25,
};
